module.exports = __webpack_public_path__ + "Icono_Usuarios_Blanco_126px.png";